import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import { GTMServiceExtendedAdapter } from "../adapter/GTMServiceExtendedAdapter";
import { BuildGtmItem } from "./BuildGtmItem";
import type { GTM } from "./GTMInterfaces";

function excludeNilValues<T extends object>(object: T) {
  return omitBy<T>(object, isNil) as T;
}

function fixedIndex(item: GTM.Item, index: number) {
  return { ...item, index };
}

function normalizeCoupon(coupon: string | undefined): string | undefined {
  return isEmpty(coupon) ? undefined : coupon;
}

export function buildGtmEventEcommerceFromServices({
  itemListId,
  services,
  eventName,
  coupon: originalCoupon,
  value,
  paymentType,
  userData,
  affiliation,
  transactionId,
  currency,
  tax,
  clientId,
  gclid,
}: GTM.EventEcommerceFromServices): GTM.EventEcommerce {
  const gtmItemBuilder = new BuildGtmItem(itemListId);

  function fromServiceToGtmItem(service: GTM.ServiceExtended) {
    const serviceAdapter = new GTMServiceExtendedAdapter(service);
    return gtmItemBuilder.fromService(serviceAdapter);
  }

  const items: GTM.Item[] = services.map(fromServiceToGtmItem).map(fixedIndex);

  const coupon = normalizeCoupon(originalCoupon);

  const ecommerce = excludeNilValues<GTM.Ecommerce>({
    value,
    items,
    coupon,
    affiliation,
    payment_type: paymentType,
    transaction_id: transactionId,
    tax,
    currency,
  });

  const event = excludeNilValues<GTM.EventEcommerce>({
    event: eventName,
    coupon,
    ecommerce,
    userData,
    client_id: clientId,
    gclid,
  });

  return event;
}
